var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"toast-container"},[_c('div',{staticClass:"toast",class:[_vm.visible ? 'fade-in' : 'fade-out']},[_c('p',[_vm._v(_vm._s(_vm.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }